// import './app.css'
// import routes from './routes';
// import MUITheme from './utils/theme'
// import { CssBaseline } from "@mui/material";
// import { useRoutes } from 'react-router-dom';
// import { SnackbarProvider } from 'notistack';

// function App() {
//   const content =  useRoutes(routes);

//   return (
//     <MUITheme>
//       <SnackbarProvider>
//         <CssBaseline />
//         {content}
//       </SnackbarProvider>
//     </MUITheme>
//   );
// }
// export default App;


import './app.css';
import routes from './routes';
import { useRoutes } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import ThemeWrapper from './ThemeWrapper';

function App() {
  const content = useRoutes(routes);

  return (
    <ThemeWrapper>
      <SnackbarProvider>
        {content}
      </SnackbarProvider>
    </ThemeWrapper>
  );
}

export default App;